import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import {
  CreateListingTermsAndCondition,
  ListingCheckoutTermsAndCondition,
} from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const tm_sandbox_marketplace: TTeamConfig = {
  TEAM_SCHEMA: "tm_sandbox_marketplace",
  TEAM_FULL_NAME: "TM Sandbox Marketplace",
  BROWSER_TITLE: "TM Sandbox Marketplace",
  CLIENT_ID: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,
  MARKETPLACE_VENDOR: constants.vendorUUIDs.stripe,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#10B981",
    COLORS_SECONDARY: "#10B981",
    DEFAULT_APP_ROUTE: routes.home,
    DEFAULT_APP_ROUTE_AFTER_LOGIN: routes.home,
    IS_MARKETPLACE_ENABLED: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
  },

  MARKETPLACE_GLOBAL_SETTINGS: {
    MARKETPLACE_REDIRECT_WARN_MODAL_DESCRIPTION:
      "You’re entering a peer-to-peer marketplace where fans can buy and sell tickets directly with each other. Prices are set by other fans and are not controlled by the team.",
    STRIPE_KYC_CONFIRMATION_MODAL_DESCRIPTION:
      "Attend uses Stripe as a secure payment processor. You’re about to leave this page to complete seller onboarding, where we’ll collect your name, address, phone number, and bank details so we can deposit your payout once your ticket sells.",
    LISTING_CHECKOUT_TERMS_AND_CONDITION: <ListingCheckoutTermsAndCondition />,
    CREATE_LISTING_TERMS_AND_CONDITION: <CreateListingTermsAndCondition />,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },
    ZERO_STATE: {
      TITLE: " ",
      DESCRIPTION:
        "No events are currently available for purchase. Please check back later.",
    },
  },

  IMAGES: {
    // Must be a real URL — the marketplace nav bar and event cards pass this
    // straight into next/image, and an empty string renders a broken image.
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png",
  },

  LANGUAGES: {
    FAQS: [],
  },
};
